
export const userService = {
    login,
    autorization,
    logout
};

function login(username, password) {
    const request = {
        method: 'POST',
        cache: "no-cache",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };
    return fetch("/Security/Login", request).then((response) => response.json());
}


function autorization(username, password) {
    const request = {
        method: 'POST',
        cache: "no-cache",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password, isAutorization : true})
    };
    return fetch("/Security/Autorization", request).then((response) => response.json());
}




function logout() {
    localStorage.removeItem('user');
}



// WEBPACK FOOTER //
// ./src/components/Login/LoginService.js